import React, { useRef } from 'react';

import useStyles from 'isomorphic-style-loader/useStyles';

import { useSectionViewTracking } from '../CustomHook/useSectionViewTracking';
import { LanguageLandingPage } from '../../../global-interfaces';
import s from './WhatCanIAchieve.scss';
import { LanguageLandingPageWhatCanIAchieveType } from '../../../../../api/public/static-pages-api';
import { LocalizedLink } from '../../../../../shared/public/LocalizedLink/LocalizedLink';

interface IWhatCanIAchieveProps {
	data: LanguageLandingPageWhatCanIAchieveType;
}

export function WhatCanIAchieve({ data }: IWhatCanIAchieveProps): JSX.Element {
	useStyles(s);
	const element = useRef<HTMLElement>(null);

	useSectionViewTracking({
		ref: element,
		sectionName: LanguageLandingPage.WhatCanIAchieve,
		sectionTitle: data.title,
	});

	return (
		<section
			className="sl-language__what-can-i-achieve"
			ref={element}
			sl-test-data="cmpLanguageWhatCanIAchieve"
		>
			<h2 className="sl-language__what-can-i-achieve__title">
				{data.title}
			</h2>
			<p className="sl-language__what-can-i-achieve__description">
				{data.description}
			</p>
			<div className="sl-language__what-can-i-achieve__container">
				{data.children.map((item) => (
					<div
						className="sl-language__what-can-i-achieve__item"
						key={item.learningPath.header.id}
					>
						<img
							src={item.learningPath.header.logo}
							alt={item.learningPath.header.title}
							className="sl-language__what-can-i-achieve__item__pic"
						/>
						<h3 className="sl-language__what-can-i-achieve__item__title">
							{item.learningPath.header.title}
						</h3>
						<p className="sl-language__what-can-i-achieve__item__description">
							{item.learningPath.header.description}
						</p>
						<div className="sl-language__what-can-i-achieve__item__courses-title">
							{item.learningPath.header.courses.title}
						</div>
						<ul className="sl-language__what-can-i-achieve__item__courses-list">
							{item.learningPath.header.courses.items.map(
								(course) => (
									<li key={course.title}>
										<LocalizedLink to={course.url}>
											{course.title}
										</LocalizedLink>
									</li>
								),
							)}
						</ul>
					</div>
				))}
			</div>
		</section>
	);
}
